import { gql } from "@apollo/client";

export const FETCH_SUPPLIER_STOCK_OVERVIEW = gql`
  query FETCH_SUPPLIER_STOCK_OVERVIEW {
    spSupplierStockOverview
  }
`;

export const FETCH_SUPPLIER_STOCK_PRODUCTS = gql`
  query FETCH_SUPPLIER_STOCK_PRODUCTS {
    supplierStockProducts {
      id
      odooId
      name
      nameCn
      number
      supplierStockPlanningQty
    }
  }
`;

export const FETCH_PRODUCT_STOCK_DETAIL = gql`
  query FETCH_PRODUCT_STOCK_DETAIL($id: ID!) {
    product(id: $id) {
      id
      odooId
      number
      name
      nameCn
    }
    spProductStockHistory(productId: $id, includeNotConfirmedPlans: false)
  }
`;

export const CREATE_SUPPLIER_STOCK_UPDATE_REQUEST = gql`
  mutation CREATE_SUPPLIER_STOCK_UPDATE_REQUEST(
    $supplierId: ID!
    $data: String!
  ) {
    createSupplierStockUpdateRequest(supplierId: $supplierId, data: $data) {
      supplierStockUpdateRequest {
        id
        state
      }
    }
  }
`;

export const FETCH_SUPPLIER_STOCK_UPDATE_REQUESTS = gql`
  query FETCH_SUPPLIER_STOCK_UPDATE_REQUESTS(
    $ids: [ID]
    $offset: Int
    $limit: Int
  ) {
    supplierStockProducts {
      id
      number
      name
      nameCn
    }
    spSupplierStockUpdateRequests(
      options: { limit: $limit, offset: $offset }
      ids: $ids
    ) {
      total
      results {
        id
        data
        createdAt
        updatedBy {
          id
          email
        }
        state
      }
    }
  }
`;
